export const EMPTY_STORE = "EMPTY_STORE"